import { createDarkTheme, createLightTheme, webDarkTheme, webLightTheme } from "@fluentui/tokens";
import { fabricSemanticTokensLight, fabricSemanticTokensDark } from "./fabricSemanticTokens";
import { fabricSizeTokenValues } from "./sizeTokens";
const brandFabric = {
    10: `#001919`,
    20: `#012826`,
    30: `#01322E`,
    40: `#033F38`,
    50: `#054D43`,
    60: `#0A5C50`,
    70: `#0C695A`,
    80: `#117865`,
    90: `#1F937E`,
    100: `#2AAC94`,
    110: `#3ABB9F`,
    120: `#52C7AA`,
    130: `#78D3B9`,
    140: `#9EE0CB`,
    150: `#C0ECDD`,
    160: `#E3F7Ef`
};
const fabricLightBase = createLightTheme(brandFabric);
const fabricDarkBase = createDarkTheme(brandFabric);
const fabricLightTheme = {
    ...fabricLightBase,
    ...fabricSemanticTokensLight,
    ...fabricSizeTokenValues
};
const fabricDarkTheme = {
    ...fabricDarkBase,
    ...fabricSemanticTokensDark,
    ...fabricSizeTokenValues
};
/**
 * # setTheme

 * #### Set the theme to the root or a specific element. Defaults to setting the theme to the document element.

 * @param theme FluentUI theme object
 * @param target The target element to set the theme to. Defaults to the document element.
 * @param callback A callback function to run after the theme is set. Usefule for running an injector to inject components after theme is loaded.
 * @returns Promise that resolves after the theme is set and callback is executed
 */
async function setTheme(theme, target, callback) {
    let targetElement = null;
    const fabricTheme = document.querySelector("[data-theme='fabric-theme']");
    if (fabricTheme) {
        fabricTheme.remove();
    }
    if (target) {
        if (target === "root") {
            const cssVariables = Object.entries(theme)
                .map(([key, value]) => `--${key}: ${value};`)
                .join(" ");
            const styleElement = document.createElement("style");
            styleElement.innerHTML = `:root { ${cssVariables} }`;
            styleElement.dataset.theme = "fabric-theme";
            styleElement.id = "fabric-ux-theme";
            document.head.appendChild(styleElement);
        }
        else {
            targetElement = document.querySelector(target);
        }
    }
    else {
        targetElement = document.documentElement;
    }
    if (targetElement) {
        Object.entries(theme).forEach(([key, value]) => {
            targetElement.style.setProperty(`--${key}`, value);
        });
    }
    document.dispatchEvent(new CustomEvent("themeLoaded", {
        detail: {
            target: targetElement?.tagName || "root"
        },
        bubbles: true
    }));
    if (callback && typeof callback === "function") {
        return new Promise((resolve) => {
            setTimeout(() => {
                callback();
                resolve();
            }, 0);
        });
    }
    return Promise.resolve();
}
export { fabricDarkTheme, fabricLightTheme, setTheme, webDarkTheme, webLightTheme };
